<template>
  <div class="change-password">
    <el-form
      :model="applyForm"
      ref="applyForm"
      :rules="rulesForm"
      label-width="86px"
    >
      <el-form-item label="原始密码" class="forget-box" prop="oldPassword">
        <el-input
          :type="showOldPassword ? 'text' : 'password'"
          maxlength="32"
          v-model="applyForm.oldPassword"
          autocomplete="off"
          placeholder="密码长度6-32位，包含数字和字母"
        >
          <i
            slot="suffix"
            class="el-icon-invisible"
            @click="showPwd('showOldPassword')"
            :class="{ see: showOldPassword }"
          ></i>
        </el-input>
        <a
          href="javascript:void(0)"
          class="forget-password"
          @click="goto_get_password"
          >已有账号，忘记密码</a
        >
        <!-- <el-input v-model="applyForm.oldPassword" autocomplete="off" placeholder="密码长度6-32位，包含数字和字母"></el-input> -->
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input
          :type="showPassword ? 'text' : 'password'"
          v-model="applyForm.pass"
          autocomplete="off"
          maxlength="32"
          placeholder="密码长度6-32位，包含数字和字母"
        >
          <i
            slot="suffix"
            class="el-icon-invisible"
            @click="showPwd('showPassword')"
            :class="{ see: showPassword }"
          ></i>
        </el-input>
        <!-- <el-input v-model="applyForm.pass" placeholder="密码长度6-32位，包含数字和字母"></el-input> -->
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input
          :type="showCheckPd ? 'text' : 'password'"
          v-model="applyForm.checkPass"
          autocomplete="off"
          maxlength="32"
          placeholder="密码长度6-32位，包含数字和字母"
        >
          <i
            slot="suffix"
            class="el-icon-invisible"
            @click="showPwd('showCheckPd')"
            :class="{ see: showCheckPd }"
          ></i>
        </el-input>
        <!-- <el-input v-model="applyForm.checkPass" placeholder="密码长度6-32位，包含数字和字母"></el-input> -->
      </el-form-item>
      <el-form-item label="">
        <el-button @click="updatePassword">保存修改</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { updatePassword } from "@/api/profile";
import variables from "@/styles/variables.scss";
import { mapActions } from "vuex";
export default {
  name: "change_password",
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入原始密码"));
      } else {
        if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,32}$/.test(value)) {
          callback(new Error("请输入6-32位英文字母和数字的组合")); // 或者符号（除空格），且字母、数字和标点符号至少包含两种
        } else {
          callback();
        }
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else {
        if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,32}$/.test(value)) {
          callback(new Error("请输入6-32位英文字母和数字的组合")); // 或者符号（除空格），且字母、数字和标点符号至少包含两种
        } else {
          if (this.applyForm.checkPass !== "") {
            this.$refs.applyForm.validateField("checkPass");
          }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码"));
      }
      if (!/^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,32}$/.test(value)) {
        // ([^\u4e00-\u9fa5\s])
        callback(new Error("请输入6-32位英文字母和数字的组合"));
      } else if (value !== this.applyForm.pass) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      showOldPassword: false,
      showPassword: false,
      showCheckPd: false,
      applyForm: {
        id: this.$store.state.user.id,
        oldPassword: "",
        pass: "",
        checkPass: "",
      },
      rulesForm: {
        oldPassword: [
          { required: true, message: "请输入原始密码", trigger: "blur" },
          // { validator: validateOldPass, trigger: "blur" },
        ],
        pass: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPass: [
          { required: true, message: "请再次输入新密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    ...mapActions("user", ["resetToken"]),
    showPwd(name) {
      this[name] = !this[name];
    },
    updatePassword() {
      const postData = {
        id: this.applyForm.id,
        oldPassword: this.applyForm.oldPassword,
        password: this.applyForm.pass,
      };
      this.$refs.applyForm.validate(async (valid) => {
        if (valid) {
          const { data } = await updatePassword(postData);
          this.$message.success("密码修改成功,请重新登陆");
          setTimeout(() => {
            this.$store
              .dispatch("user/resetToken")
              .then((res) => {
                this.$router.push("/login");
              })
              .catch((err) => {
                this.$message.error(err);
              });
          }, 3000);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    goto_get_password() {
      this.resetToken("resetToken");
      this.$router.push("/get_back_password");
    },
  },
};
</script>
<style lang="scss">
.change-password {
  text-align: left;
  font-size: 14px;
  .el-form {
    .el-form-item__label {
      text-align: left;
      color: #343438;
    }
    // .el-input__suffix{
    // 	width: 36px;
    // }

    .el-form-item {
      margin: 24px 0;
      width: calc(100% - 142px);
      &.forget-box {
        position: relative;
        .forget-password {
          position: absolute;
          margin: 0;
          padding: initial;
          width: inherit;
          display: inline-block;
          right: -24px;
          top: 0;
          transform: translateX(100%);
          color: #514def;
        }
      }

      .el-form-item__error {
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
        position: absolute;
        left: initial !important;
        top: -5px !important;
        right: 0px !important;
        transform: translateY(-100%) !important;
      }
      .el-form-item__content {
        .el-button {
          width: 200px;
          height: 42px;
          background: #514def;
          color: #ffffff;
          border-radius: 4px;
          border: none;
          &:hover {
            border-color: #5f5bfb;
            background-color: #5f5bfb;
          }
        }
        .el-icon-invisible {
          display: inline-block;
          width: 36px;
          height: 100%;
          background: url("~@/assets/images/btn_key_invisible_normal.png")
            no-repeat;
          background-position: center;
          cursor: pointer;
          &:hover {
            background-image: url("~@/assets/images/btn_key_invisible_hover.png");
          }
          &.see {
            background-image: url("~@/assets/images/btn_key_visible_normal.png");
            &:hover {
              background-image: url("~@/assets/images/btn_key_visible_hover.png");
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.change-password {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before {
    content: "";
    margin-right: 0px;
  }
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after,
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label::after {
    content: "*";
    color: #ff4949;
    margin-left: 4px;
  }
}
</style>
